import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { BaseControl } from "../../controls";
let FormTitle = class FormTitle extends BaseControl {
    get tips() {
        return this.controlOpts.tips;
    }
};
FormTitle = tslib_1.__decorate([
    Component({
        name: 'form-title'
    })
], FormTitle);
export default FormTitle;
